import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { DeleteDialog } from "../components";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  bookkeepingId: number
  isUsedInDocuments: boolean
}

const BankAccountOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);

  const onDelete = async () => {
    await window.CoreApi.Bookkeeping.Delete({ bookkeepingId: props.bookkeepingId });
    window.location.href = props.listUrl;
  };

  return <>
    <GeneralOptionsPanel
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: !props.isUsedInDocuments,
        }
      ]}
      data={props.optionsPanelData}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
  </>;
};

export default BankAccountOptionsPanel;